"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlchemyWebSocketProvider = exports.AlchemyProvider = void 0;

var _properties = require("@ethersproject/properties");

var _formatter = require("./formatter");

var _websocketProvider = require("./websocket-provider");

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

var _urlJsonRpcProvider = require("./url-json-rpc-provider");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var logger = new _logger.Logger(_version.version);
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
var defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";

var AlchemyWebSocketProvider = /*#__PURE__*/function (_WebSocketProvider) {
  _inherits(AlchemyWebSocketProvider, _WebSocketProvider);

  var _super = _createSuper(AlchemyWebSocketProvider);

  function AlchemyWebSocketProvider(network, apiKey) {
    var _this;

    _classCallCheck(this, AlchemyWebSocketProvider);

    var provider = new AlchemyProvider(network, apiKey);
    var url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
    _this = _super.call(this, url, provider.network);
    (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "apiKey", provider.apiKey);
    return _this;
  }

  _createClass(AlchemyWebSocketProvider, [{
    key: "isCommunityResource",
    value: function isCommunityResource() {
      return this.apiKey === defaultApiKey;
    }
  }]);

  return AlchemyWebSocketProvider;
}(_websocketProvider.WebSocketProvider);

exports.AlchemyWebSocketProvider = AlchemyWebSocketProvider;

var AlchemyProvider = /*#__PURE__*/function (_UrlJsonRpcProvider) {
  _inherits(AlchemyProvider, _UrlJsonRpcProvider);

  var _super2 = _createSuper(AlchemyProvider);

  function AlchemyProvider() {
    _classCallCheck(this, AlchemyProvider);

    return _super2.apply(this, arguments);
  }

  _createClass(AlchemyProvider, [{
    key: "isCommunityResource",
    value: function isCommunityResource() {
      return this.apiKey === defaultApiKey;
    }
  }], [{
    key: "getWebSocketProvider",
    value: function getWebSocketProvider(network, apiKey) {
      return new AlchemyWebSocketProvider(network, apiKey);
    }
  }, {
    key: "getApiKey",
    value: function getApiKey(apiKey) {
      if (apiKey == null) {
        return defaultApiKey;
      }

      if (apiKey && typeof apiKey !== "string") {
        logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
      }

      return apiKey;
    }
  }, {
    key: "getUrl",
    value: function getUrl(network, apiKey) {
      var host = null;

      switch (network.name) {
        case "homestead":
          host = "eth-mainnet.alchemyapi.io/v2/";
          break;

        case "ropsten":
          host = "eth-ropsten.alchemyapi.io/v2/";
          break;

        case "rinkeby":
          host = "eth-rinkeby.alchemyapi.io/v2/";
          break;

        case "goerli":
          host = "eth-goerli.alchemyapi.io/v2/";
          break;

        case "kovan":
          host = "eth-kovan.alchemyapi.io/v2/";
          break;

        case "matic":
          host = "polygon-mainnet.g.alchemy.com/v2/";
          break;

        case "maticmum":
          host = "polygon-mumbai.g.alchemy.com/v2/";
          break;

        case "arbitrum":
          host = "arb-mainnet.g.alchemy.com/v2/";
          break;

        case "arbitrum-rinkeby":
          host = "arb-rinkeby.g.alchemy.com/v2/";
          break;

        case "optimism":
          host = "opt-mainnet.g.alchemy.com/v2/";
          break;

        case "optimism-kovan":
          host = "opt-kovan.g.alchemy.com/v2/";
          break;

        default:
          logger.throwArgumentError("unsupported network", "network", arguments[0]);
      }

      return {
        allowGzip: true,
        url: "https:/" + "/" + host + apiKey,
        throttleCallback: function throttleCallback(attempt, url) {
          if (apiKey === defaultApiKey) {
            (0, _formatter.showThrottleMessage)();
          }

          return Promise.resolve(true);
        }
      };
    }
  }]);

  return AlchemyProvider;
}(_urlJsonRpcProvider.UrlJsonRpcProvider);

exports.AlchemyProvider = AlchemyProvider;